var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonDownGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24751 7.13991L0.451273 1.6585C-0.114487 1.01192 0.344691 0 1.20385 0H10.7963C11.6555 0 12.1147 1.01192 11.5489 1.6585L6.75266 7.13991C6.35425 7.59524 5.64592 7.59524 5.24751 7.13991Z",
    fill: "#6B7085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonDownGrey);
export default __webpack_public_path__ + "static/media/button-down-grey.e2c731d043dbdc7d3f893635a16e8415.svg";
export { ForwardRef as ReactComponent };